export default {
	data() {
		return {
			servicesCount: 0,
			jobPersonnelRoles: [],
			partsFields: [
				{label: "Part Description",key:"description"},
				{label: "Part #",key:"part_number"},
				{label: "Qty",key:"qty",align:"right"},
				{label: "",key:'material_unit_type'}
			],
			taskFields: [
				{label:'Task Number',key:'item_number'},
				{label:'Task Description',key:'description'},
				{label:'Qty/Time',key:'qty',align:'right'},
			],
			equipmentFields: [
				{label:'Equipment Type',key:'equipmentType'},
				{label:'Equipment Description',key:'description'},
				{label:'Qty',key:'qtyWithUnit',align:'right'}
			],
			startYear: 2018,
			listFields: [
				{
					label: "Emg.",
					key: "emergencyIcon",
					align: "center"
				},
				{
					label: "Service #",
					key: "job_num"
				},
				{
					label: "Job Name",
					key: "job_name"
				},
				{
					label: "Customer",
					key: "customerCompanyName"
				},
				{
					label: "Site Address",
					key: "siteAddress",
					showOnMobile:  false
				},
				{
					label: "Est. Time (hrs)",
					key: "estimated_time",
					showOnMobile: false,
					align: 'center'
				},
				{
					label: "Scheduled",
					key: "scheduledFor",
					sortBy: "date",
					align: 'center'
				},
				{
					label: "Apt. Time",
					key: "aptTime",
					showOnMobile:  false,
					align: 'center'
				},
				{
					label: "Permit #",
					key: "permit_notification_number",
					showOnMobile:  false,
					align: 'center'
				},
				{
					label: "Is Warranty Work",
					key: "is_warranty_work",
					showOnMobile:  false,
					type: 'boolean',
					align: 'center'
				},
				{
					label: "Pays Mileage",
					key: "pays_mileage",
					showOnMobile:  false,
					type: 'boolean',
					align: 'center'
				},
				{
					label: "Pays Per Diem",
					key: "pays_per_diem",
					showOnMobile:  false,
					type: 'boolean',
					align: 'center'
				},
				{
					label: "Status",
					key: "displayStatus",
					showOnMobile: false
				}
			],
		}
	},
	computed: {
		filterButtonsArchive() {
			let buttons = [
				{text: 'All',value:'all'},
				{text: 'My List',value:'mine',title: "Services that you are assigned to either as crew membor or with personnel role"},
				{text: 'Draft',value:'draft',title: "Services that either haven't been scheduled with a time or crew"},
				{text: 'Quote',value:'quote',title: "Services that are in 'Quote' status"},
				{text: 'Dispatched',value:'dispatched'},
				{text: 'Incomplete',value:'incomplete'},
				{text: 'Completed',value:'completed'},
				{text: 'Reviewed',value:'reviewed'},
				{text: 'Processing',value: 'processing'},
				{text: 'Invoiced',value:'invoiced'},
				{text: 'Canceled',value:'canceled'},
				{text: 'Archived',value:'archived'},
			]

			/* DISABLED FOR NOW UNTIL PORTAL IS ROLLED OUT
			let modulePerms = this.getUserModulePerms
			if (this.getUserRoleType() == "Admin" || ('Service Requests' in modulePerms && modulePerms['Service Requests'].read == '1'))
				buttons.push({text: 'Requests', value:'requests'})
			*/

			return buttons
		},
		quoteRecord() {
			if (!("ServiceInvoice" in this.$store.service) || !this.$store.service.ServiceInvoice)
				return false

			return this.$store.service.ServiceInvoice.find(inv => inv.is_quote == 1)
		},
		hasChangeQuoteRecord() {
			if (this.quoteRecord) 
				return this.quoteRecord.is_change_quote == 1
			
			return false
		},
		isQuote() {
			let segs = this.segmentUrl(this.$route.path)

			if (segs[3] == 'quote' || segs[2] == 'new-quote')
				return true
			else
				return false

		},
		serviceStatusIncompleteGroup() {
			let status = this.$store.serviceStatuses.find(stat => this.$store.service.status == stat.label)

			if (status)
				if (!("incompleteGroup" in status) || !status.incompleteGroup)
					return false

			return true
		},
		serviceHasBatchInvoice() {
			if (("BatchInvoice" in this.$store.service && this.$store.service.BatchInvoice ) || ("invoice_id" in this.$store.service && this.$store.service.invoice_id > 0))
				return true
			else
				return false
		},
		requiredRoleListServices() {
			return this.$store.jobPersonnelRoles.filter(role => role.role_required_service == 1)
		},
		hasAllRequiredRoles() {
			let hasMissingRole = false
			let vm = this

			this.requiredRoleListServices.forEach(reqRole => {
				if (!vm.$store.service.JobPersonnelRole || !vm.$store.service.JobPersonnelRole.find(role => reqRole.id == role.id))
					hasMissingRole = true
			})

			return !hasMissingRole
		},
		isScheduled() {
			if (this.$store.service.assigned_to > 0 && this.$store.service.due_date && this.$store.service.appointment_time)
				return true
			else
				return false
		},
		serviceHeadingTitle() {
			let jobNum = "[tbd]"
			if ("job_num" in this.$store.service)
				jobNum = this.$store.service.job_num

			let quoteLabel = ""
			if (this.$store.service.status == 'Quote')
				quoteLabel = " Quote "

			if (this.heading) 
				return this.heading + ": Service"+quoteLabel+" #"+jobNum
			else 
				return "Service "+quoteLabel+"#" +jobNum
			
		},
		serviceHeadingSmall() {
			if (Object.keys(this.$store.service).length > 0) {
				let address = this.$store.service.address

				if (this.$store.service.city)
					address += " "+this.$store.service.city

				return address
			}
			else
				return ""
		},
		isNew() {
			let vm = this

			if (vm.$route.params.id == 'new' || vm.$route.params.id == 'new-quote')
				return true

			else
				return false
		},
		mutatedServices() {
			let vm = this

			if (this.$store.services) {

				let completedStatuses = vm.getCompleteStatuses()

				let services = this.$store.services

				if (this.$store.serviceFilterArchiveValue == 'mine') {

					if ('myListStatusFilter' in this && this.myListStatusFilter != 'All') {
						if (this.myListStatusFilter == 'Dispatched')
							services = services.filter(service => service.status == 'Dispatched' || service.status == '')
						else if (this.myListStatusFilter == 'Incomplete') {
							let omit = ["Quote","Canceled","Dispatched"]
							services = services.filter(service => completedStatuses.indexOf(service.status) == -1 && omit.indexOf(service.status) == -1)
						}
						else
							services = services.filter(service => service.status == this.myListStatusFilter)
					}
					if ('myListCustomerFilter' in this && this.myListCustomerFilter) 
						services = services.filter(service => service.customer_id == this.myListCustomerFilter)	
				}

				return services.map(service => {

					service.dateLanded = service.date_landed

					service.displayStatus = service.status

					if (service.status == 'Completed')
						service.displayStatus = "Completed " + vm.formatDate(service.completed)

					service.quoteStatus = ""
					if ("ServiceInvoice" in service && service.ServiceInvoice) {

						let quote = service.ServiceInvoice.find(inv => inv.is_quote == 1)

						if (quote) {
							
							if (quote.finalized == 0)
								service.quoteStatus = "Unfinalized"
						 	else if (quote.quote_status)
								service.quoteStatus = quote.quote_status
							else
								service.quoteStatus = "Pending Approval"

						}
					}

					if (service.status == "") 
						service.displayStatus = "Draft"
					else if (!service.status || service.status == "Dispatched")
						service.displayStatus = "Dispatched"
					else if (vm.$store.serviceFilterArchiveValue == "reviewed") {
						//sort out which is "completed" and which is "reviewed"
						service.displayStatus = "Reviewed"
					}
					else if (vm.$store.serviceFilterArchiveValue == 'completed') {
						let reviewed = true
						if (service.TimeLog && service.TimeLog.forEach(log => {
							if (log.submitted_by == 0)
								reviewed = false
						}))

						if (reviewed) 
							service.displayStatus = "Reviewed"
					}

					if (vm.$store.serviceFilterArchiveValue == 'mine' && service.quoteStatus && service.status == "Quote")
						//add quote status to main service status
						service.displayStatus += " (Quote: "+service.quoteStatus+")"

					service.customerCompanyName = ""
					if ("customer_name_cache" in service && service.customer_name_cache)
						service.customerCompanyName = service.customer_name_cache
					else if ("Customer" in service && service.Customer)
						service.customerCompanyName = service.Customer.name

					let siteAddress = ""
					if ("ContactLocation" in service && service.ContactLocation)
						siteAddress += "<em>"+service.ContactLocation.location_name+"</em><br>"

					siteAddress += service.address
					if (service.city)
						siteAddress += ", " + service.city

					service.siteAddress = siteAddress

					service.emergencyIcon = ""
					if (service.is_emergency == 1)
						service.emergencyIcon = "<i class='fa fa-exclamation text-danger'></i>"

					service.scheduledFor = ""
					service.aptTime = ""
					if ("scheduled_datetime" in service && service.scheduled_datetime) {
						service.scheduledFor = vm.formatDateTimeToLocal(service.scheduled_datetime)
						service.aptTime = vm.formatDateTimeToLocal(service.scheduled_datetime,'time')
					}
					else if ("due_date" in service && service.due_date && "appointment_time" in service && service.appointment_time) {
						service.scheduledFor = vm.formatDateTime(service.due_date + " " + service.appointment_time)
					}
					else {
						service.scheduledFor = "<span class='text-danger'><i class='fa fa-question'></i> Not Scheduled</span>"
						service.aptTime = ""
					}

					/*
					if ("helper_techs_json" in service) {
						let techList = []
						try {
							techList = JSON.parse(service.helper_techs_json)
						}
						catch (e) {}

						if (techList.length > 0)
							service.techList += " and "+techList.length +" helper(s)"
					}
					*/

					//convert HTML entities by using a textarea
					let description = document.createElement('textarea')
					description.innerHTML = service.description
					description = description.value

					service.rowTitle = description
						.replace(/(<([^>]+)>)/ig,"")
						.replace(/(\r\n|\n|\r)/gm," ")
						.substring(0,300)
					service.rowTitle += "..."

					if ("JobPersonnelRole" in service && service.JobPersonnelRole) {
						service.JobPersonnelRole.forEach(role => {
							if (role.display_on_listings == 1) {
								if ("User" in service && service.User) {
									let user = service.User.find(user => user.id == role.user_id)

									if (user) 
										service['personnelRole' + role.id] = user.first_name + " " + user.last_name
								}
							}
						})
					}

					if (service && "ScheduleEvent" in service && service.ScheduleEvent && service.ScheduleEvent.length > 0)
						service.priorityIndex = service.ScheduleEvent[0].priority_index

					console.log(service)

					return service
				})
			}
			else
				return []
		},
		//Filters for the quick filter buttons at top
		filteringFilters() {

			let filters = []

			let filterValue = this.$store.serviceFilterArchiveValue

			if (filterValue == 'draft') {
				filters.push(["status",["","Draft"]])
				filters.push(["archived",0])

				/*
				filters.push(["completed",null,"or"])
				filters.push(["archived",0])
				filters.push(["is_canceled",0])
				filters.push(["assigned_to <",1])
				filters.push(["status",["","Draft"]])

				filters.push(["completed",null,"or"])
				filters.push(["archived",0])
				filters.push(["is_canceled",0])
				filters.push(["due_date",null])
				filters.push(["status",["","Draft"]])
				*/
			}
			else if (filterValue == "quote") {
				filters.push(["archived",0])
				filters.push(["is_canceled",0])
				filters.push(["status","Quote"])
			}
			else if (filterValue == "dispatched") {
				filters.push(["status",'Dispatched'])
				filters.push(["archived",0])
			}
			else if (filterValue == "incomplete") {
				filters.push(["archived",0])
				filters.push(["is_canceled",0])
				filters.push(["status","Incomplete","and","like"])
			}
			else if (filterValue == 'completed') { 
				filters.push(["status",'Completed'])
				filters.push(["archived",0])
			}
			else if (filterValue == 'reviewed') {
				filters.push(['status','Reviewed'])
				filters.push(["archived",0])
			}
			else if (filterValue == 'processing') {
				filters.push(['status','Processing'])
				filters.push(["archived",0])
			}
			else if (filterValue == 'invoiced') {
				filters.push(["status",'Invoiced'])
				filters.push(["archived",0])
			}
			else if (filterValue == 'archived') {
				filters.push(["archived",1])
			}
			else if (filterValue == 'canceled') {
				filters.push(["is_canceled",1])
				filters.push(["archived",0])
			}
			else if (filterValue == "mine") {
				//return 2 sets of filters

				filters.push(["archived",0])
				filters.push(['is_canceled',0])

				let filterSet = {
					a: this.cloneObj(filters),
					b: this.cloneObj(filters)
				}

				filterSet.a.push(["assigned_to",this.$store.userDetails.id])

				filterSet.a.push(['helper_techs_json','"'+this.$store.userDetails.id+'"',"or","like"])
				filterSet.a.push(["archived",0])
				filterSet.a.push(['is_canceled',0])

				filterSet.b.push(["User.id",this.$store.userDetails.id])

				filters = filterSet
			}
			else if (filterValue == 'all') {
				filters.push(["archived",0])
			}

			if (this.$store.serviceFilterYearValue == "pre") {

				let dateFilter = ['date_landed <',this.startYear+'-01-01']

				if (Array.isArray(filters))
					filters.push(dateFilter)
				else {
					filters.a.push(dateFilter)
					filters.b.push(dateFilter)
				}
				
			}
			else {
				if (this.$store.serviceFilterYearValue != "all") {
					let dateStart = ['date_landed >',this.$store.serviceFilterYearValue+'-01-01']
					let dateEnd = ['date_landed <',this.$store.serviceFilterYearValue+'-12-31'] 

					if (Array.isArray(filters)) {
						filters.push(dateStart)
						filters.push(dateEnd)
					}
					else {
						filters.a.push(dateStart)
						filters.a.push(dateEnd)
						filters.b.push(dateStart)
						filters.b.push(dateEnd)	
					}
				}
			}

			return filters
		}
	},
	methods: {
		mutatedFields(params) {
			let fields = JSON.parse(JSON.stringify(this.listFields));

			let displayFields = ['emergencyIcon','job_num','customerCompanyName','siteAddress','estimated_time','scheduledFor','aptTime','siteAddress','displayStatus'] //default
			try {
				displayFields = JSON.parse(this.$store.company.CompanySetting.custom_service_list_fields_json)
			}
			catch (e) {}

			let trimmedFields = []

			fields.forEach((field,index) => {
				if (displayFields.indexOf(field.key) >= 0)
					trimmedFields.push(field)
			})

			fields = trimmedFields

			let tabsWithStatusField = ["all","archived","mine","incomplete"]
			if (!fields.find(field => field.key == 'displayStatus') && tabsWithStatusField.indexOf(this.$store.serviceFilterArchiveValue) >= 0) {		
				//put status back in
				fields.push({
					label: "Status",
					key: "displayStatus",
					showOnMobile: false
				})			
			}

			this.$store.jobPersonnelRoles.forEach(role => {
				if (role.display_on_listings == 1) {
					fields.push({
						label: role.title,
						key: "personnelRole"+role.id,
						showOnMobile: false
					})
				}
			})

			if (this.$store.serviceFilterArchiveValue == 'quote') {
				fields.push({
					label: "Quote Status",
					key: "quoteStatus",
					showOnMobile: false
				})
			}

			//remove some field to make room for expanded map
			if (this.mapExpanded) {
				fields = fields.filter(field => {
					if ("showOnMobile" in field)
						return false
					else
						return true
				})
			}

			if (params) {
				if ("exclude" in params)
					fields = fields.filter(field => params.exclude.indexOf(field.key) == -1 && params.exclude.indexOf(field.label) == -1)
				
			}

			fields.push({label: 'Priority',key:'priorityIndex'})

			return fields
		},
		getCompleteStatuses() {
			return this.$store.serviceStatuses.filter(status => {
				if (!("incompleteGroup" in status) || !status.incompleteGroup)
					return true
			}).map(status => {
				return status.label
			})
		},
		hasRoleAssigned(role_id) {
			if ("JobPersonnelRole" in this.$store.service)
				return this.$store.service.JobPersonnelRole.find(role => role.id == role_id)
			else
				return false
		},
		mutateImage(img,isAfter) {
			let vm = this

			let rootUrl = window.apiRoot+'resources/images/'+vm.$store.sessionToken+'/'

			img.thumbUrl = ""
			img.fullUrl = ""
			if ("UploadFile" in img && img.UploadFile) {

				if (img.UploadFile.thumb_filename == "") 
					img.thumbUrl = rootUrl+img.UploadFile.filename+"?v="+img.updated_at
				
				else
					img.thumbUrl = rootUrl+img.UploadFile.thumb_filename+"?v="+img.updated_at

				img.fullUrl = rootUrl+img.UploadFile.filename+"?v="+img.updated_at

			}

			return img
		},
		/**
		* requiredProperties: an array containing a list of Models that must be inlcuded in $store.service, otherwise a fresh fetch will be made
		*/
		setServiceIfNotSet(requiredProperties) {
			let vm = this

			return new Promise((resolve,reject) => {

				let needsFetch = false

				if (requiredProperties) {
					let hasAllProperties = true
					requiredProperties.forEach(key => {
						if (!(key in vm.$store.service))
							hasAllProperties = false
					})

					if (!hasAllProperties)
						needsFetch = true
				}
				else {
					//if not set, just check for 'id'
					if (!("id" in this.$store.service))
						needsFetch = true
				}

				let promises = []

				if (needsFetch || !("slug" in vm.$store.service) || vm.$store.service.slug != vm.$route.params.id)
					promises.push(vm.fetchService())

				if (vm.$store.collectiveAgreements.length == 0)
					promises.push(vm.getJSON("CollectiveAgreement/get",{include:["Union"]}))

				if (promises.length > 0) {

					Promise.all(promises).then(responses => {

						if (responses.length == 2)
							vm.$store.collectiveAgreements = responses[1].data

						resolve(responses[0])
					})

				}
				else {
					resolve({data:vm.$store.service})
				}

			})
		},
		/**
		* Returns a compiled object:
		* {
		* 	description: string,
		*	tasks: array
		*	materials: array
		*	equipment: array
		* }
		* 
		* worksheets param should be a collection of ServiceWorksheet models
		*/
		joinWorksheets(worksheets,job_num = "") {
			let vm = this

			let tasks = []
			let equipment = []
			let materials = []
			let workCompleted = []
			let serviceTasks = []

			if (worksheets) {
				worksheets.forEach(entry => {

					if (!("is_change_quote_work" in entry) || entry.is_change_quote_work == 0) {
						let entryTasks = vm.isValidJSON(entry.tasks_completed_json) ? JSON.parse(entry.tasks_completed_json) : []
						let entryMaterials = vm.isValidJSON(entry.parts_used_json) ? JSON.parse(entry.parts_used_json) : []
						let entryEquipment = vm.isValidJSON(entry.equipment_used_json) ? JSON.parse(entry.equipment_used_json) : []
						let entryServiceTasks = vm.isValidJSON(entry.service_tasks_completed_json) ? JSON.parse(entry.service_tasks_completed_json) : []

						//add worksheet date to each task/material/equipment item
						entryTasks = entryTasks.map(item => {
							item.worksheet_date = entry.created_at

							return item
						})
						entryMaterials = entryMaterials.map(item => {
							item.worksheet_date = entry.created_at

							return item
						})
						entryEquipment = entryEquipment.map(item => {
							item.worksheet_date = entry.created_at

							return item
						})
						entryServiceTasks = entryServiceTasks.map(item => {
							item.worksheet_date = entry.created_at

							return item
						})

						tasks = tasks.concat(entryTasks)
						equipment = equipment.concat(entryEquipment)
						materials = materials.concat(entryMaterials)
						serviceTasks = serviceTasks.concat(entryServiceTasks)
					}

					let entryDate = vm.moment.utc(entry.created_at).local().format("MMM DD")

					let workCompletedEntry = "<p><strong>"+entryDate+": #"+job_num+"</strong><br>"
					if ("CustomerAsset" in entry && entry.CustomerAsset)
						workCompletedEntry += "Asset: "+entry.CustomerAsset.description+" (S/N "+entry.CustomerAsset.serial_num+")</p>"

					workCompletedEntry += entry.work_completed_description

					workCompleted.push(workCompletedEntry)
				})
			}

			workCompleted = workCompleted.join("<hr>")

			return {
				description: workCompleted,
				tasks,
				materials,
				equipment,
				serviceTasks
			}
		},
		clockInToService() {
			let vm = this

			this.getLocation().then(location => {

				let distance = vm.getDistance(location.lat,location.lng,vm.$store.service.lat,vm.$store.service.long)

				if (distance < vm.$store.service.check_in_tolerance) {
					let payload = {
						job_id: 0,
						service_id: vm.$store.service.id,
						currentLat: location.lat,
						currentLong: location.lng,
						position_accuracy: location.accuracy
					}

					this.postData("TimeLog/punch-clock",payload).then(function(response){
						if (response.success) {

							if (!vm.clockInOtherUser) {
								let clockInState = "onsite"
								if ("clocked_in_offsite" in response.data && response.data.clocked_in_offsite == 1)
									clockInState = "offsite"

								vm.$bus.$emit("clockStatusChanged",clockInState)
							} 

							if ("time_in" in response.data)
								vm.$store.clockinTime = response.data.time_in
							else
								vm.$store.clockinTime = null
						}
					})

				}
				else {
					//not on site, redirect to main clock in page
					vm.$router.push("/punch-clock/service/"+vm.$store.service.slug)
				}

			}).catch(error => {

				vm.showLocationError = true
				
			})

		},
		fetchService() {
			let vm = this

			this.spinner(true)

			return new Promise((resolve,reject) => {

				let include = [
					{model: "ServiceContact",include: [{model: "Contact",include:["Contact"]}]},
					{model:"Contact",include:["ContactLocation"]},
					{model: "ServiceContract", include: ["ServiceContractTask"]},
					{	
						model: "ServiceFile", 
						include: [{model: "UploadFile",fields:["id","slug","type","original_filename","filename","thumb_filename"]}],
						fields:["id","slug","is_after","is_file","caption","notes"]
					},
					{
						model: "User",
						fields: ["id","slug","first_name","last_name","personnel_role_id","user_id","phone_mobile"]
					},
					{
						model: "TimeLog",
						include: [{
							model: "User",
							include: ["EmployeeClassification"],
							fields: ["id","slug","first_name","last_name"]
						}],
						fields: [
							"id",
							"slug",
							"regular_hours",
							"overtime_hours_15x",
							"overtime_hours_2x",
							"overtime_hours_25x",
							"user_id",
							"service_id",
							"job_id",
							"collective_agreement_json",
							"time_in",
							"time_out",
							"time_on_site",
							"calculated_cost"
						]
					},
					{
						model: "ServiceWorksheet",
						include: [
							{
								model: "User",
								fields: ["id","slug","first_name","last_name"]
							},
							{
								model: "CustomerAsset",
								fields: ["description","serial_number"]
							}
						]
					},
					{
						model: "Job",
						fields: ["id","slug","job_num","job_name"]
					},
					{
						model: "ScheduleEvent",
						limit: 1
					},
					{
						model: "Category",
						include: ["JobChecklist"]
					},
					{
						model: "JobChecklist",
						include: [
							{
								model: "CustomerAsset",
								fields: ["id", "slug", "description"]
							},
							"Category"
						]
					},
					{ model: "FormChildTemplate", fields: ['id'] },
					{ model: "Checklist", fields: ["id"]},
					"ContactLocation",
					"JobPersonnelRole",
					"ServiceInvoice",
					"ServiceQuote",
					"Expense",
					"PayBoost",
					"CustomerAsset"
				]

				this.getJSON("Service/find/"+this.$route.params.id,{include,include_deleted: true},true).then(response => {

					if (response.success) {
						vm.$set(vm.$store,"service",response.data)
						vm.$store.service.payboost_ids = vm.primitize(response.data.PayBoost,"payboost_id")
						if (!vm.$store.service.status)
							vm.$store.service.status = "Draft"

						vm.$store.service.is_emergency = parseInt(vm.$store.service.is_emergency)

						// Fetch helpers
						if ('helper_techs_json' in response.data && response.data.helper_techs_json) {

							try {
								let helperTechs = JSON.parse(response.data.helper_techs_json)

								if (helperTechs.length > 0) {
									let helperParams = {
										fields: ["first_name", "last_name"],
										filters: [
											["id", helperTechs]
										]
									}
									vm.getJSON("User/get", helperParams).then(helperResponse => {
										if (helperResponse.success)
											vm.$set(vm.$store.service,"HelperTechs",helperResponse.data)
										
									})
								}
							}
							catch (e) {}
						}
					}

					vm.spinner(false)

					resolve(response)
				})

			})
		},
		fetchServiceTasks() {
			let vm = this

			let params = {
				filters: [
					["contract_id",0]
				]
			}

			return new Promise((resolve,reject) => {

				vm.getJSON("ServiceContractTask/get",params).then(response => {
					if (response.success)
						vm.$store.serviceTasks = response.data
					
					resolve(response)
				})
			})
		},
		fetchCustomerContracts(filters) {
			let vm = this

			return new Promise((resolve,reject) => {

				let params = {
					filters: [
						["customer_id",vm.$store.service.customer_id],
						["end_date >",vm.moment().format("YYYY-MM-DD")]
					]
				}
				if (filters)
					params.filters = filters
				
				vm.getJSON("ServiceContract/get",params).then(response => {

					vm.$emit("contractOptionsChange",response.data)

					resolve(response)
				})
			})
		}
	}
}
